import { useState } from "react";
import { SectionHeader } from "./SectionHeader";

const FAQS = [
  { q: "¿Es gratis?", a: "CuadraAI ofrece una prueba gratuita para que conozcas todas sus funciones antes de decidir un plan." },
  { q: "¿Necesito instalarla?", a: "No. Funciona directamente desde el navegador, pero puedes instalarla como aplicación (PWA) para acceder más rápido." },
  { q: "¿Funciona sin internet?", a: "CuadraAI necesita conexión a internet para sincronizar tu información de forma segura en la nube." },
  { q: "¿Mis datos son seguros?", a: "Sí. Tu información se almacena con la infraestructura de Firebase y nunca se comparte ni se vende a terceros." },
  { q: "¿Cómo recupero mi cuenta?", a: "Desde la pantalla de inicio de sesión puedes solicitar un enlace de recuperación a tu correo registrado." },
];

export default function FAQ({ C }) {
  const [open, setOpen] = useState(0);
  return (
    <section style={{ padding: "64px 20px", maxWidth: 720, margin: "0 auto" }}>
      <SectionHeader C={C} eyebrow="Preguntas frecuentes" title="Resolvemos tus dudas" />
      <div style={{ marginTop: 32, display: "flex", flexDirection: "column", gap: 10 }}>
        {FAQS.map((item, i) => {
          const isOpen = open === i;
          return (
            <div key={item.q} style={{
              background: C.bgCard, border: `1px solid ${isOpen ? C.borderHi : C.border}`,
              borderRadius: 14, overflow: "hidden", transition: "border 0.2s",
            }}>
              <button
                onClick={() => setOpen(isOpen ? -1 : i)}
                aria-expanded={isOpen}
                style={{
                  width: "100%", background: "transparent", border: "none", cursor: "pointer",
                  padding: "16px 18px", display: "flex", alignItems: "center", justifyContent: "space-between",
                  color: C.text, fontWeight: 700, fontSize: 14.5, fontFamily: "inherit", textAlign: "left",
                }}
              >
                {item.q}
                <span style={{ color: C.primary, fontSize: 18, transform: isOpen ? "rotate(45deg)" : "none", transition: "transform 0.2s" }}>+</span>
              </button>
              {isOpen && (
                <div style={{ padding: "0 18px 16px", color: C.muted, fontSize: 13.5, lineHeight: 1.6, animation: "fadeIn 0.25s ease" }}>
                  {item.a}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
